import React from 'react';

function LayoutRow({ children }) {
  return <div className="h-full d-flex layout-wrap">{children}</div>;
}
export default LayoutRow;
